import React, { useEffect, useState } from 'react';

import { Avatar as AvatarDisplay } from "../index.jsx"
import { IconButton, Icon } from "../ui";
import { ImageUploadModal } from '../modals';
import { getFileUrl } from "../../core/config/api.js";

import "./avatar-input.scss";

const buildFileSrc = fileId => getFileUrl(fileId);

const AvatarInput = ({ field, form, user, value, onAvatarChange, className = '', startOpened = false }) => {
    const defaultFileId = field?.value ? field.value : value
    const defaultSrc = defaultFileId ? buildFileSrc(defaultFileId) : null

    const [file, setFile] = useState(defaultFileId ? { id: defaultFileId } : null)
    const [open, setOpen] = useState(startOpened)

    useEffect(() => {
        setOpen(startOpened);
    }, [startOpened]);

    const closeEdit = () => {
        setOpen(false)
    }

    const openEdit = () => {
        setOpen(true)
    }

    const onSetFile = (data) => {
        if (data) setFile(data);
        form && form.setFieldValue(
            field.name,
            data?.id
        );

        onAvatarChange && onAvatarChange(data?.id)
        setOpen(false)
    }

    return (
        <div className={`avatar-input ${className}`}>
            <ImageUploadModal open={open} defaultSrc={defaultSrc} onSetFile={onSetFile} closeModal={closeEdit} modalProps={{ title: "Upload profile picture" }} />
            <>
                <AvatarDisplay
                    fileId={file && file.id}
                    onClick={openEdit}
                    user={user}
                />
                {/* Fontaine M56B: shared IconButton, not the legacy
                    `.input-button` <a> badge (theme.css icon-image pill).
                    The create-page avatar keeps hiding it — users-dark's
                    `.avatar-input button { display: none }` still applies. */}
                <IconButton
                    variant="default"
                    size="sm"
                    round
                    label="Edit photo"
                    className="avatar-input__edit"
                    onClick={openEdit}
                >
                    <Icon name="Pencil" size="xs" />
                </IconButton>
            </>
        </div>
    )
};

export default AvatarInput;
